(() => {
  const root = window.Shopify?.routes?.root || "/";
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector(".site-nav");
  const searchToggle = document.querySelector(".search-toggle");
  const search = document.querySelector(".header-search");
  const header = document.querySelector("[data-site-header]");
  let menuReturnFocus;
  let searchReturnFocus;
  const focusable = (container) => [...container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((item) => !item.hidden && item.offsetParent !== null);
  const syncHeaderCompact = () => {
    const menuOpen = toggle?.getAttribute("aria-expanded") === "true";
    const searchOpen = searchToggle?.getAttribute("aria-expanded") === "true";
    // Leave enough hysteresis for the header's height transition and browser
    // scroll anchoring: shrinking must not immediately trigger expansion.
    const compact = header?.classList.contains("is-compact");
    header?.classList.toggle("is-compact", window.scrollY > (compact ? 32 : 96) && !menuOpen && !searchOpen);
  };

  const setMenu = (open) => {
    if (!toggle || !nav) return;
    toggle.setAttribute("aria-expanded", String(open));
    nav.classList.toggle("is-open", open);
    document.body.classList.toggle("menu-open", open);
    const label = toggle.querySelector("[data-menu-label]");
    if (label) label.textContent = open ? toggle.dataset.closeLabel : toggle.dataset.openLabel;
    if (open) {
      menuReturnFocus = toggle;
      setSearch(false);
      requestAnimationFrame(() => focusable(nav)[0]?.focus());
    } else if (document.activeElement && nav.contains(document.activeElement)) {
      (menuReturnFocus || toggle).focus();
    }
    syncHeaderCompact();
  };
  const setSearch = (open) => {
    if (!searchToggle || !search) return;
    searchToggle.setAttribute("aria-expanded", String(open));
    search.hidden = !open;
    if (open) {
      searchReturnFocus = document.activeElement;
      setMenu(false);
      search.querySelector("input")?.focus();
    } else if (document.activeElement && search.contains(document.activeElement)) {
      (searchReturnFocus || searchToggle).focus();
    }
    syncHeaderCompact();
  };

  toggle?.addEventListener("click", () => setMenu(toggle.getAttribute("aria-expanded") !== "true"));
  nav?.addEventListener("click", (event) => {
    if (event.target.closest("a")) setMenu(false);
  });
  searchToggle?.addEventListener("click", () => setSearch(searchToggle.getAttribute("aria-expanded") !== "true"));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Tab" && toggle?.getAttribute("aria-expanded") === "true" && nav) {
      const items = focusable(nav);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    if (event.key !== "Escape") return;
    if (toggle?.getAttribute("aria-expanded") === "true") {
      setMenu(false);
      toggle.focus();
    }
    if (searchToggle?.getAttribute("aria-expanded") === "true") {
      setSearch(false);
      searchToggle.focus();
    }
  });
  document.addEventListener("click", (event) => {
    if (toggle?.getAttribute("aria-expanded") === "true" && !nav?.contains(event.target) && !toggle.contains(event.target)) setMenu(false);
    if (searchToggle?.getAttribute("aria-expanded") === "true" && !search?.contains(event.target) && !searchToggle.contains(event.target)) setSearch(false);
  });
  matchMedia("(min-width: 901px)").addEventListener?.("change", (event) => {
    if (event.matches) setMenu(false);
  });
  window.addEventListener("scroll", syncHeaderCompact, { passive: true });
  syncHeaderCompact();
  document.querySelectorAll(".header-search input[type=search]").forEach((input) => {
    const clear = input.parentElement?.querySelector("[data-search-clear]");
    const sync = () => { if (clear) clear.hidden = !input.value; };
    input.addEventListener("input", sync);
    clear?.addEventListener("click", () => { input.value = ""; sync(); input.focus(); });
    sync();
  });
  document.querySelectorAll("[data-predictive-search]").forEach((predictive) => {
    const form = predictive.querySelector("[data-predictive-form]");
    const input = form?.querySelector('input[type="search"]');
    const results = predictive.querySelector("[data-predictive-results]");
    const status = predictive.querySelector("[data-predictive-status]");
    if (!form || !input || !results || !status) return;
    const storageKey = `seifenlaedeli-recent-searches:${document.documentElement.lang || "de"}`;
    let controller;
    let timer;
    let options = [];
    let active = -1;
    const readRecent = () => {
      try { return JSON.parse(localStorage.getItem(storageKey) || "[]").filter((value) => typeof value === "string").slice(0, 5); }
      catch (error) { return []; }
    };
    const saveRecent = (query) => {
      const normalized = query.trim();
      if (!normalized) return;
      try { localStorage.setItem(storageKey, JSON.stringify([normalized, ...readRecent().filter((value) => value.toLocaleLowerCase() !== normalized.toLocaleLowerCase())].slice(0, 5))); }
      catch (error) { /* Search still works when storage is unavailable. */ }
    };
    const closeResults = () => {
      results.hidden = true;
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
      options = [];
      active = -1;
    };
    const openResults = () => {
      results.hidden = false;
      input.setAttribute("aria-expanded", "true");
    };
    const setOptions = () => { options = [...results.querySelectorAll('[role="option"]')]; active = -1; };
    const message = (text) => {
      results.replaceChildren();
      const paragraph = document.createElement("p");
      paragraph.className = "header-search__message";
      paragraph.textContent = text;
      results.append(paragraph);
      status.textContent = text;
      openResults();
      setOptions();
    };
    const renderRecent = () => {
      const recent = readRecent();
      if (!recent.length) { closeResults(); return; }
      results.replaceChildren();
      const heading = document.createElement("p");
      heading.className = "header-search__message";
      heading.textContent = predictive.dataset.recentLabel;
      results.append(heading);
      recent.forEach((query, index) => {
        const row = document.createElement("div");
        row.className = "header-search__recent";
        const link = document.createElement("a");
        link.className = "header-search__result";
        link.id = `RecentSearch-${index}`;
        link.role = "option";
        link.href = `${root}search?q=${encodeURIComponent(query)}`;
        link.textContent = query;
        const remove = document.createElement("button");
        remove.type = "button";
        remove.dataset.removeRecent = query;
        remove.setAttribute("aria-label", `${predictive.dataset.removeLabel}: ${query}`);
        remove.replaceChildren(document.createTextNode("×"));
        row.append(link, remove);
        results.append(row);
      });
      openResults();
      setOptions();
    };
    const renderProducts = (products) => {
      results.replaceChildren();
      products.forEach((product, index) => {
        const link = document.createElement("a");
        link.className = "header-search__result";
        link.id = `PredictiveSearch-${index}`;
        link.role = "option";
        link.href = product.url;
        if (product.image) {
          const image = document.createElement("img");
          image.src = product.image;
          image.alt = "";
          image.width = 48;
          image.height = 48;
          link.append(image);
        }
        const copy = document.createElement("span");
        const title = document.createElement("strong");
        title.textContent = product.title;
        copy.append(title);
        if (product.price) {
          const price = document.createElement("small");
          price.textContent = product.price;
          copy.append(price);
        }
        link.append(copy);
        results.append(link);
      });
      if (!products.length) message(predictive.dataset.emptyLabel);
      else {
        status.textContent = `${products.length}`;
        openResults();
        setOptions();
      }
    };
    const requestSuggestions = () => {
      window.clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      if (!query) { renderRecent(); return; }
      timer = window.setTimeout(async () => {
        controller = new AbortController();
        status.textContent = predictive.dataset.loadingLabel;
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
          const timeout = window.setTimeout(() => controller.abort(), 8000);
          const response = await fetch(url, { headers: { Accept: "application/json" }, signal: controller.signal });
          window.clearTimeout(timeout);
          if (!response.ok) throw new Error(String(response.status));
          const payload = await response.json();
          renderProducts(payload.resources?.results?.products || []);
        } catch (error) {
          if (error.name !== "AbortError") message(predictive.dataset.errorLabel);
        }
      }, 220);
    };
    input.addEventListener("focus", requestSuggestions);
    input.addEventListener("input", requestSuggestions);
    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") { closeResults(); setSearch(false); return; }
      if (!["ArrowDown", "ArrowUp", "Enter"].includes(event.key) || !options.length) return;
      if (event.key === "Enter" && active < 0) return;
      event.preventDefault();
      if (event.key === "Enter") { options[active].click(); return; }
      active = event.key === "ArrowDown" ? (active + 1) % options.length : (active - 1 + options.length) % options.length;
      options.forEach((option, index) => option.setAttribute("aria-selected", String(index === active)));
      input.setAttribute("aria-activedescendant", options[active].id);
    });
    form.addEventListener("submit", () => saveRecent(input.value));
    results.addEventListener("click", (event) => {
      const remove = event.target.closest("[data-remove-recent]");
      if (!remove) return;
      try { localStorage.setItem(storageKey, JSON.stringify(readRecent().filter((query) => query !== remove.dataset.removeRecent))); }
      catch (error) { /* No-op when storage is unavailable. */ }
      renderRecent();
      input.focus();
    });
  });
  document.querySelectorAll(".recovery-search input[type=search]").forEach((input) => {
    const clear = input.parentElement?.querySelector("[data-recovery-search-clear]");
    const sync = () => { if (clear) clear.hidden = !input.value; };
    input.addEventListener("input", sync);
    clear?.addEventListener("click", () => { input.value = ""; sync(); input.focus(); });
    sync();
  });
  document.querySelector(".recovery-page h1[tabindex='-1']")?.focus({ preventScroll: true });

  const syncSearchClear = (input) => {
    const clear = input.closest(".search-page__field")?.querySelector("[data-search-clear]");
    if (clear) clear.hidden = !input.value;
  };
  document.querySelectorAll(".search-page input[type=search]").forEach(syncSearchClear);
  document.addEventListener("input", (event) => {
    if (event.target.matches(".search-page input[type=search]")) syncSearchClear(event.target);
  });
  let searchRequest;
  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-native-search]")) return;
    event.preventDefault();
    if (form.dataset.submitting === "true") return;

    const searchRoot = form.closest("[data-search-root]");
    const submitButton = form.querySelector("[data-search-submit]");
    const status = searchRoot?.querySelector("[data-search-status]");
    const retry = searchRoot?.querySelector("[data-search-retry]");
    if (!searchRoot || !submitButton || !status || !retry) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    searchRequest?.abort();
    const controller = new AbortController();
    searchRequest = controller;
    let timedOut = false;
    const timeout = window.setTimeout(() => {
      timedOut = true;
      controller.abort();
    }, 10000);
    const target = new URL(form.action, window.location.href);
    new FormData(form).forEach((value, key) => target.searchParams.set(key, String(value)));
    form.dataset.submitting = "true";
    searchRoot.setAttribute("aria-busy", "true");
    status.textContent = searchRoot.dataset.loadingLabel;
    status.classList.remove("error");
    retry.hidden = true;
    submitButton.disabled = true;
    submitButton.textContent = searchRoot.dataset.submittingLabel;

    try {
      const response = await fetch(target, {
        headers: { Accept: "text/html" },
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(String(response.status));
      const documentResult = new DOMParser().parseFromString(await response.text(), "text/html");
      const nextRoot = documentResult.querySelector("[data-search-root]");
      if (!nextRoot) throw new Error("Invalid search response");
      document.title = documentResult.title || document.title;
      searchRoot.replaceWith(nextRoot);
      const nextInput = nextRoot.querySelector('input[type="search"]');
      if (nextInput) syncSearchClear(nextInput);
      window.history.pushState({ nativeSearch: true }, "", target);
      const heading = nextRoot.querySelector("h1");
      heading?.setAttribute("tabindex", "-1");
      heading?.focus();
    } catch (error) {
      status.textContent = timedOut ? searchRoot.dataset.timeoutLabel : searchRoot.dataset.errorLabel;
      status.classList.add("error");
      retry.hidden = false;
      submitButton.disabled = false;
      submitButton.textContent = submitButton.dataset.defaultLabel;
    } finally {
      window.clearTimeout(timeout);
      if (searchRequest === controller) searchRequest = undefined;
      delete form.dataset.submitting;
      searchRoot.removeAttribute("aria-busy");
    }
  });
  document.addEventListener("click", (event) => {
    const retry = event.target.closest("[data-search-retry]");
    if (retry) retry.closest("[data-search-root]")?.querySelector("[data-native-search]")?.requestSubmit();
    const clear = event.target.closest(".search-page [data-search-clear]");
    if (clear) {
      const input = clear.closest(".search-page__field")?.querySelector('input[type="search"]');
      if (input) {
        input.value = "";
        syncSearchClear(input);
        input.focus();
      }
    }
  });
  window.addEventListener("popstate", () => {
    if (document.querySelector("[data-search-root]")) window.location.reload();
  });

  document.addEventListener("change", (event) => {
    const select = event.target.closest("[data-search-sort] select");
    if (select) select.form?.requestSubmit();
  });
  const cartForm = document.querySelector("[data-cart-form]");
  if (cartForm) {
    const status = cartForm.querySelector("[data-cart-status]");
    const updated = sessionStorage.getItem("cart-update-success");
    if (updated === "true" && status) {
      status.textContent = cartForm.dataset.successLabel;
      sessionStorage.removeItem("cart-update-success");
    }
    const setCartBusy = (busy) => {
      cartForm.setAttribute("aria-busy", String(busy));
      cartForm.querySelectorAll("button,input,textarea").forEach((control) => { control.disabled = busy; });
    };
    const confirmCartMutation = async (url, body) => {
      if (cartForm.dataset.submitting === "true") return;
      cartForm.dataset.submitting = "true";
      if (status) {
        status.textContent = cartForm.dataset.loadingLabel;
        status.classList.remove("error");
      }
      setCartBusy(true);
      const controller = new AbortController();
      let timedOut = false;
      const timeout = window.setTimeout(() => { timedOut = true; controller.abort(); }, 10000);
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: { Accept: "application/json" },
          body,
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("Cart update rejected");
        const confirmedCart = await response.json();
        if (!confirmedCart || !Array.isArray(confirmedCart.items)) throw new Error("Invalid cart response");
        sessionStorage.setItem("cart-update-success", "true");
        window.location.reload();
      } catch (error) {
        if (status) {
          status.textContent = timedOut ? cartForm.dataset.timeoutLabel : cartForm.dataset.errorLabel;
          status.classList.add("error");
        }
        delete cartForm.dataset.submitting;
        setCartBusy(false);
      } finally {
        window.clearTimeout(timeout);
      }
    };
    cartForm.addEventListener("click", async (event) => {
      const step = event.target.closest("[data-quantity-step]");
      if (step) {
        const line = step.closest("[data-cart-line]");
        const input = line?.querySelector("[data-cart-quantity]");
        if (!input || !line.dataset.lineKey) return;
        const quantity = Math.max(0, Math.min(99, Number(input.value || 0) + Number(step.dataset.quantityStep)));
        const body = new FormData();
        body.set("id", line.dataset.lineKey);
        body.set("quantity", String(quantity));
        await confirmCartMutation(`${root}cart/change.js`, body);
      }
      const remove = event.target.closest("[data-cart-remove]");
      if (remove) {
        const line = remove.closest("[data-cart-line]");
        if (!line?.dataset.lineKey) return;
        const body = new FormData();
        body.set("id", line.dataset.lineKey);
        body.set("quantity", "0");
        await confirmCartMutation(`${root}cart/change.js`, body);
      }
    });
    cartForm.addEventListener("submit", async (event) => {
      if (event.submitter?.name === "checkout") {
        if (status) status.textContent = cartForm.dataset.checkoutLabel;
        return;
      }
      if (event.submitter?.name !== "update") return;
      event.preventDefault();
      if (cartForm.dataset.submitting === "true") return;
      const quantities = [...cartForm.querySelectorAll("[data-cart-quantity]")];
      if (quantities.some((input) => !input.validity.valid || !Number.isInteger(Number(input.value)))) {
        if (status) { status.textContent = cartForm.dataset.invalidLabel; status.classList.add("error"); }
        quantities.find((input) => !input.validity.valid || !Number.isInteger(Number(input.value)))?.focus();
        return;
      }
      const cartPayload = new FormData(cartForm);
      await confirmCartMutation(`${root}cart/update.js`, cartPayload);
    });
  }

  document.querySelectorAll("[data-hero-rotator]").forEach((rotator) => {
    const slides = [...rotator.querySelectorAll(".hero__slide")];
    if (slides.length < 2) return;
    const hero = rotator.closest(".hero");
    const dots = [...hero.querySelectorAll("[data-hero-dot]")];
    const current = hero.querySelector("[data-hero-current]");
    const rotationControl = hero.querySelector("[data-hero-rotation]");
    const rotationIcon = rotationControl?.querySelector("[data-hero-rotation-icon]");
    const rotationLabel = rotationControl?.querySelector("[data-hero-rotation-label]");
    const reducedMotionQuery = matchMedia("(prefers-reduced-motion: reduce)");
    const rtl = document.documentElement.dir === "rtl";
    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    let interactionPaused = false;
    let userPaused = reducedMotionQuery.matches;
    let timer;
    let pointerStart;
    let campaignActive = false;

    const syncTone = (slide) => {
      hero.dataset.heroTone = slide.classList.contains("hero__slide--ink") ? "ink" : "light";
    };
    const show = (next, announce = false) => {
      if (campaignActive) next = 0;
      const normalized = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === normalized;
        if (!selected && slide.contains(document.activeElement)) hero.querySelector("[data-hero-next]")?.focus();
        slide.hidden = !selected;
        slide.classList.toggle("is-active", selected);
        slide.setAttribute("aria-hidden", String(!selected));
        slide.querySelectorAll("a,button,input,select,textarea,[tabindex]").forEach((item) => {
          if (!selected) item.setAttribute("tabindex", "-1");
          else if (item.getAttribute("tabindex") === "-1") item.removeAttribute("tabindex");
        });
      });
      dots.forEach((dot, index) => {
        const selected = index === normalized;
        dot.classList.toggle("is-active", selected);
        dot.setAttribute("aria-current", String(selected));
        if (selected) {
          const progress = dot.querySelector(".hero__progress");
          if (progress) {
            progress.style.animation = "none";
            progress.offsetWidth;
            progress.style.animation = "";
          }
        }
      });
      if (current) current.textContent = String(normalized + 1);
      syncTone(slides[normalized]);
      active = normalized;
      if (announce) slides[normalized].setAttribute("aria-live", "polite");
      window.setTimeout(() => slides[normalized].removeAttribute("aria-live"), 50);
    };
    const resume = () => {
      window.clearInterval(timer);
      if (!campaignActive && !interactionPaused && !userPaused && !reducedMotionQuery.matches && !document.hidden) timer = window.setInterval(() => show(active + 1), 6000);
    };
    const syncRotationControl = () => {
      if (!rotationControl) return;
      const actionLabel = userPaused ? rotationControl.dataset.playLabel : rotationControl.dataset.pauseLabel;
      rotationControl.setAttribute("aria-pressed", String(userPaused));
      rotationControl.setAttribute("aria-label", actionLabel || "");
      if (rotationLabel) rotationLabel.textContent = actionLabel || "";
      if (rotationIcon) rotationIcon.textContent = userPaused ? "▶" : "Ⅱ";
      hero.classList.toggle("is-rotation-paused", userPaused || interactionPaused || reducedMotionQuery.matches);
    };
    const setInteractionPaused = (value) => {
      interactionPaused = value;
      syncRotationControl();
      value ? window.clearInterval(timer) : resume();
    };
    rotationControl?.addEventListener("click", () => {
      userPaused = !userPaused;
      syncRotationControl();
      resume();
    });
    hero.querySelector("[data-hero-previous]")?.addEventListener("click", () => { show(active - 1, true); resume(); });
    hero.querySelector("[data-hero-next]")?.addEventListener("click", () => { show(active + 1, true); resume(); });
    dots.forEach((dot, index) => dot.addEventListener("click", () => { show(index, true); resume(); }));
    hero.addEventListener("pointerenter", () => setInteractionPaused(true));
    hero.addEventListener("pointerleave", () => setInteractionPaused(false));
    hero.addEventListener("focusin", () => setInteractionPaused(true));
    hero.addEventListener("focusout", (event) => {
      if (!hero.contains(event.relatedTarget)) setInteractionPaused(false);
    });
    hero.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      const direction = event.key === "ArrowRight" ? 1 : -1;
      show(active + (rtl ? -direction : direction), true);
      resume();
    });
    hero.addEventListener("pointerdown", (event) => {
      if (event.pointerType === "mouse") return;
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    hero.addEventListener("pointerup", (event) => {
      if (!pointerStart || event.pointerType === "mouse") return;
      const x = event.clientX - pointerStart.x;
      const y = event.clientY - pointerStart.y;
      pointerStart = undefined;
      if (Math.abs(x) < 45 || Math.abs(x) < Math.abs(y)) return;
      show(active + (x < 0 ? (rtl ? -1 : 1) : (rtl ? 1 : -1)), true);
      resume();
    });
    document.addEventListener("visibilitychange", resume);
    hero.addEventListener("hero:campaign", (event) => {
      campaignActive = event.detail?.active === true;
      if (campaignActive) show(0);
      resume();
    });
    reducedMotionQuery.addEventListener?.("change", () => {
      if (reducedMotionQuery.matches) userPaused = true;
      syncRotationControl();
      resume();
    });
    show(active);
    syncRotationControl();
    resume();
  });

  document.querySelectorAll("img[data-image-fallback]").forEach((image) => {
    image.addEventListener("error", () => image.classList.add("is-broken"), { once: true });
  });

  document.querySelectorAll("[data-review-rotator]").forEach((rotator) => {
    let slides = [...rotator.querySelectorAll("[data-review-slide]")];
    const previous = rotator.querySelector("[data-review-previous]");
    const next = rotator.querySelector("[data-review-next]");
    const rotation = rotator.querySelector("[data-review-rotation]");
    const counter = rotator.querySelector("[data-review-counter]");
    const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
    if (slides.length < 2 || !previous || !next || !rotation || !counter) return;
    let active = 0;
    let timer;
    let userPaused = reducedMotion.matches;
    let pointerPaused = false;
    let focusPaused = false;
    const stop = () => { window.clearInterval(timer); timer = undefined; };
    const syncRotation = () => {
      const paused = userPaused || reducedMotion.matches;
      rotation.setAttribute("aria-pressed", String(paused));
      rotation.setAttribute("aria-label", paused ? rotation.dataset.playLabel : rotation.dataset.pauseLabel);
      rotation.querySelector("span").textContent = paused ? "▶" : "Ⅱ";
    };
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.hidden = !selected;
        slide.classList.toggle("is-active", selected);
      });
      counter.textContent = `${active + 1} / ${slides.length}`;
    };
    const start = () => {
      stop();
      if (userPaused || pointerPaused || focusPaused || reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => show(active + 1), 6500);
    };
    const move = (amount) => {
      show(active + amount);
      start();
    };
    rotator.addEventListener("seife:reviews-loaded", () => {
      slides = [...rotator.querySelectorAll("[data-review-slide]")];
      stop();
      if (slides.length) { show(0); start(); }
    });
    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
    rotation.addEventListener("click", () => {
      userPaused = !userPaused;
      syncRotation();
      start();
    });
    rotator.addEventListener("pointerenter", () => { pointerPaused = true; stop(); });
    rotator.addEventListener("pointerleave", () => { pointerPaused = false; start(); });
    rotator.addEventListener("focusin", () => { focusPaused = true; stop(); });
    rotator.addEventListener("focusout", () => {
      requestAnimationFrame(() => {
        focusPaused = rotator.contains(document.activeElement);
        start();
      });
    });
    document.addEventListener("visibilitychange", start);
    reducedMotion.addEventListener?.("change", () => { syncRotation(); start(); });
    show(active);
    syncRotation();
    start();
  });

  const cartConfirmation = document.querySelector("[data-cart-confirmation]");
  const cartConfirmationClose = cartConfirmation?.querySelector("[data-cart-confirmation-close]");
  const cartConfirmationHome = cartConfirmation?.parentElement;
  let cartConfirmationDialog;
  if (cartConfirmation?.showPopover) cartConfirmation.setAttribute("popover", "manual");
  const observedCartCount = document.querySelector("[data-cart-count]");
  let previousCartCount = Number.parseInt(observedCartCount?.textContent || "0", 10) || 0;
  let cartConfirmationTimer;
  let cartConfirmationConcealTimer;
  const hideCartConfirmation = () => {
    if (!cartConfirmation) return;
    window.clearTimeout(cartConfirmationTimer);
    cartConfirmation.classList.remove("is-visible");
    cartConfirmationConcealTimer = window.setTimeout(() => {
      if (!cartConfirmation.classList.contains("is-visible")) {
        if (cartConfirmation.hidePopover && cartConfirmation.matches(":popover-open")) cartConfirmation.hidePopover();
        cartConfirmation.hidden = true;
        cartConfirmationHome?.append(cartConfirmation);
        cartConfirmationDialog?.removeEventListener("close", hideCartConfirmation);
        cartConfirmationDialog = null;
      }
    }, 180);
  };
  const showCartConfirmation = () => {
    if (!cartConfirmation) return;
    window.clearTimeout(cartConfirmationTimer);
    window.clearTimeout(cartConfirmationConcealTimer);
    cartConfirmationDialog?.removeEventListener("close", hideCartConfirmation);
    // A modal dialog makes the rest of the document inert. Keep the notice
    // inside it for interaction, then use the top layer to escape clipping.
    cartConfirmationDialog = [...document.querySelectorAll("dialog[open]")].reverse().find(dialog => dialog.matches(":modal"));
    (cartConfirmationDialog || cartConfirmationHome)?.append(cartConfirmation);
    cartConfirmationDialog?.addEventListener("close", hideCartConfirmation, { once: true });
    cartConfirmation.hidden = false;
    if (cartConfirmation.showPopover && !cartConfirmation.matches(":popover-open")) cartConfirmation.showPopover();
    requestAnimationFrame(() => cartConfirmation.classList.add("is-visible"));
    cartConfirmationTimer = window.setTimeout(hideCartConfirmation, 7000);
  };
  cartConfirmationClose?.addEventListener("click", hideCartConfirmation);
  if (observedCartCount) {
    new MutationObserver(() => {
      const nextCartCount = Number.parseInt(observedCartCount.textContent || "0", 10) || 0;
      if (nextCartCount > previousCartCount) showCartConfirmation();
      previousCartCount = nextCartCount;
    }).observe(observedCartCount, { childList: true, characterData: true, subtree: true });
  }

  document.querySelectorAll(".proxy-form").forEach((form) => form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (form.dataset.dataCollectionApproved !== "true") return;
    if (form.dataset.submitting === "true") return;
    const status = form.querySelector(".form-status");
    const button = form.querySelector('button[type="submit"],button:not([type])');
    if (!status || !button) return;
    const values = Object.fromEntries(new FormData(form).entries());
    if (form.classList.contains("b2b-form")) values.consentToContact = values.consentToContact === "true";
    status.textContent = "";
    status.classList.remove("error");
    form.dataset.submitting = "true";
    button.disabled = true;
    try {
      const response = await fetch(form.action, { method: "POST", body: JSON.stringify(values), headers: { Accept: "application/json", "Content-Type": "application/json", "Idempotency-Key": crypto.randomUUID() } });
      if (!response.ok) throw new Error("Request failed");
      form.reset();
      status.textContent = form.dataset.success;
    } catch (error) {
      status.textContent = form.dataset.error;
      status.classList.add("error");
    } finally {
      delete form.dataset.submitting;
      button.disabled = false;
    }
  }));

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-product-form]")) return;
    event.preventDefault();
    if (form.dataset.submitting === "true") return;
    const button = form.querySelector("button");
    const status = form.querySelector("[data-product-status]") || form.closest(".review-commerce")?.querySelector("[data-product-status]");
    if (!button) return;
    form.dataset.submitting = "true";
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      if (!response.ok) throw new Error("Cart request failed");
      const addedItem = await response.json().catch(() => null);
      const cart = await (await fetch(`${root}cart.js`)).json();
      if (addedItem?.key) document.dispatchEvent(new CustomEvent("seife:ordinary-added", { detail: { key: addedItem.key, variantId: addedItem.variant_id || addedItem.id, cart } }));
      document.querySelectorAll("[data-cart-count]").forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      document.querySelectorAll("[data-cart-control]").forEach((control) => {
        const label = `${control.dataset.cartLabel || ""} — ${cart.item_count}`;
        control.setAttribute("aria-label", label);
        const live = control.querySelector("[data-cart-live]");
        if (live) live.textContent = label;
      });
      if (status) {
        status.textContent = form.dataset.addedLabel;
        status.classList.remove("error");
      }
    } catch (error) {
      if (form.matches("[data-review-product]")) {
        if (status) {
          status.textContent = form.closest(".review-commerce")?.dataset.addError || "";
          status.classList.add("error");
        }
        button.disabled = false;
        return;
      }
      HTMLFormElement.prototype.submit.call(form);
      return;
    } finally {
      delete form.dataset.submitting;
      button.disabled = false;
    }
  });

  const banner = document.querySelector("[data-consent-banner]");
  let consentReturnFocus;
  const focusConsent = () => requestAnimationFrame(() => focusable(banner)[0]?.focus({ preventScroll: true }));
  const consentStatus = banner?.querySelector("[data-consent-status]");
  const consentPreferences = banner?.querySelector("[data-consent-preferences]");
  const consentCustomize = banner?.querySelector("[data-consent-customize]");
  const consentSave = banner?.querySelector("[data-consent-save]");
  const consentAccept = banner?.querySelector("[data-consent-accept]");
  const consentDecline = banner?.querySelector("[data-consent-decline]");
  const consentInputs = banner ? [...banner.querySelectorAll("[data-consent-preferences] input:not([disabled])")] : [];
  const consentButtons = banner ? [...banner.querySelectorAll(".consent-banner__actions button")] : [];
  const consentValue = (value) => value === true || value === "yes";
  const setConsentStatus = (message, error = false) => {
    if (!consentStatus) return;
    consentStatus.textContent = message || "";
    consentStatus.classList.toggle("error", error);
  };
  const setConsentBusy = (busy) => {
    banner?.setAttribute("aria-busy", String(busy));
    consentInputs.forEach((input) => { input.disabled = busy; });
    consentButtons.forEach((button) => { button.disabled = busy; });
  };
  const hideConsent = () => {
    if (!banner) return;
    banner.hidden = true;
    banner.removeAttribute("aria-busy");
    setConsentStatus("");
    if (consentReturnFocus instanceof HTMLElement) consentReturnFocus.focus({ preventScroll: true });
    consentReturnFocus = undefined;
  };
  const showConsent = () => {
    if (!banner) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy && typeof privacy.shouldShowBanner === "function") {
      banner.hidden = !privacy.shouldShowBanner();
      setConsentStatus("");
      consentInputs.forEach((input) => { input.disabled = false; });
      consentButtons.forEach((button) => { button.disabled = false; });
    } else {
      banner.hidden = false;
      setConsentStatus(banner.dataset.unavailableLabel, true);
      consentAccept.disabled = true;
      consentSave.disabled = true;
      consentInputs.forEach((input) => { input.checked = false; input.disabled = true; });
    }
    if (!banner.hidden) {
      consentReturnFocus = document.activeElement;
      focusConsent();
    }
  };
  const readConsent = () => ({
    analytics: Boolean(banner?.querySelector("[data-consent-analytics]")?.checked),
    marketing: Boolean(banner?.querySelector("[data-consent-marketing]")?.checked),
    preferences: Boolean(banner?.querySelector("[data-consent-preferences-input]")?.checked),
    sale_of_data: false,
  });
  const setConsent = (choice) => {
    if (!banner || banner.getAttribute("aria-busy") === "true") return;
    const privacy = window.Shopify?.customerPrivacy;
    const preferences = typeof choice === "boolean" ? { analytics: choice, marketing: choice, preferences: choice, sale_of_data: false } : choice;
    if (!privacy || typeof privacy.setTrackingConsent !== "function") {
      setConsentStatus(banner.dataset.errorLabel, true);
      return;
    }
    if (!navigator.onLine) {
      setConsentStatus(banner.dataset.offlineLabel, true);
      return;
    }
    setConsentBusy(true);
    setConsentStatus(banner.dataset.savingLabel);
    let settled = false;
    const timeout = window.setTimeout(() => {
      if (settled) return;
      settled = true;
      setConsentBusy(false);
      setConsentStatus(banner.dataset.errorLabel, true);
    }, 10000);
    try {
      privacy.setTrackingConsent(preferences, (result) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        const current = privacy.currentVisitorConsent?.();
        const matches = !result?.error && current && ["analytics", "marketing", "preferences", "sale_of_data"].every((key) => consentValue(current[key]) === preferences[key]);
        setConsentBusy(false);
        if (!matches) {
          setConsentStatus(banner.dataset.errorLabel, true);
          return;
        }
        document.dispatchEvent(new CustomEvent("seifenlaedeli:consent-updated", { detail: preferences }));
        setConsentStatus(banner.dataset.savedLabel);
        window.setTimeout(hideConsent, 900);
      });
    } catch (error) {
      settled = true;
      window.clearTimeout(timeout);
      setConsentBusy(false);
      setConsentStatus(banner.dataset.errorLabel, true);
    }
  };
  const customizeConsent = () => {
    if (!banner || !consentPreferences) return;
    if (banner.hidden) consentReturnFocus = document.activeElement;
    const privacy = window.Shopify?.customerPrivacy;
    let current;
    try {
      current = privacy?.currentVisitorConsent?.();
    } catch (error) {
      current = null;
    }
    const analytics = banner.querySelector("[data-consent-analytics]");
    const marketing = banner.querySelector("[data-consent-marketing]");
    const preferences = banner.querySelector("[data-consent-preferences-input]");
    if (analytics) analytics.checked = current?.analytics === true || current?.analytics === "yes";
    if (marketing) marketing.checked = current?.marketing === true || current?.marketing === "yes";
    if (preferences) preferences.checked = current?.preferences === true || current?.preferences === "yes";
    banner.hidden = false;
    consentPreferences.hidden = false;
    consentCustomize.hidden = true;
    consentAccept.hidden = true;
    consentDecline.hidden = true;
    consentSave.hidden = false;
    const available = Boolean(privacy) && typeof privacy.setTrackingConsent === "function";
    setConsentStatus(available ? "" : banner.dataset.errorLabel, !available);
    consentInputs.forEach((input) => { input.disabled = !available; });
    consentSave.disabled = !available;
    consentPreferences.querySelector("input:not([disabled])")?.focus({ preventScroll: true });
  };
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-consent-accept]")) setConsent(true);
    if (event.target.closest("[data-consent-decline]")) setConsent(false);
    if (event.target.closest("[data-consent-customize]") || event.target.closest("[data-consent-manage]")) customizeConsent();
    if (event.target.closest("[data-consent-save]")) setConsent(readConsent());
  });
  document.querySelectorAll(".legal__tabs").forEach((tabs) => {
    tabs.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      const links = [...tabs.querySelectorAll(".legal__tab")];
      const current = links.indexOf(document.activeElement);
      if (current < 0 || !links.length) return;
      event.preventDefault();
      const rtl = document.documentElement.dir === "rtl";
      const delta = event.key === "ArrowRight" ? (rtl ? -1 : 1) : (event.key === "ArrowLeft" ? (rtl ? 1 : -1) : 0);
      const next = event.key === "Home" ? 0 : (event.key === "End" ? links.length - 1 : (current + delta + links.length) % links.length);
      links[next].focus();
    });
  });
  // Shopify's loader can arrive after this deferred theme asset. Do not treat
  // initialization as a failed save, or permanently disable a late-loaded API.
  if (banner) {
    let loading = false;
    let ready = false;
    let attempts = 0;
    let retry;
    const initializeConsent = () => {
      if (ready) return;
      window.clearTimeout(retry);
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.shouldShowBanner === "function" &&
          typeof privacy?.setTrackingConsent === "function") {
        ready = true;
        window.clearTimeout(retry);
        if (consentPreferences && !consentPreferences.hidden) customizeConsent();
        else showConsent();
        return;
      }
      attempts += 1;
      if (!loading && typeof window.Shopify?.loadFeatures === "function") {
        loading = true;
        try {
          window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
            if (error) loading = false;
            // The bounded poll also handles loaders that never call back.
          });
        } catch (error) {
          loading = false;
        }
      }
      if (attempts < 60) retry = window.setTimeout(initializeConsent, 250);
      else {
        showConsent();
        // A later restored connection or returning visitor can retry safely.
        attempts = 0;
        loading = false;
      }
    };
    window.addEventListener("online", initializeConsent);
    document.addEventListener("click", (event) => {
      if (!ready && event.target.closest("[data-consent-manage], [data-consent-customize], [data-consent-decline]")) {
        attempts = 0;
        initializeConsent();
      }
    });
    window.addEventListener("pageshow", () => {
      if (!ready) { window.clearTimeout(retry); initializeConsent(); }
    });
    initializeConsent();
  }
})();
